/** Joins class names, skipping the falsy ones. Library-internal: screens pass no classes. */
export const cx = (...names: (string | false | null | undefined)[]) => names.filter(Boolean).join(' ')
